import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckShield = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0.6667) scale(1.3333)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16.5 7.81429V8.50429C16.4991 10.1216 15.9754 11.6953 15.007 12.9907C14.0386 14.286 12.6775 15.2336 11.1265 15.6922C9.57557 16.1508 7.91794 16.0957 6.40085 15.5352C4.88376 14.9747 3.58849 13.9389 2.70822 12.5821C1.82795 11.2253 1.40984 9.62034 1.51626 8.00653C1.62267 6.39271 2.2479 4.85654 3.29871 3.6271C4.34951 2.39766 5.76959 1.54083 7.34714 1.1844C8.92469 0.827975 10.5752 0.991046 12.0525 1.64929M16.5 2.50429L9 10.0118L6.75 7.76179",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgCheckShield);
export default ForwardRef;
